<div class="fd-modal-content">
  <h3 fxLayoutAlign="center">Atualizar profile</h3>
  <form [formGroup]="formGroup">
    <div fxLayout="column" fxLayoutAlign="center">
      <div fxLayoutGap="20px">
        <div fxFlex="100">
          <h5 style="margin-bottom: 0.5em">Nº da Instituição</h5>
          {{getInstitutionLabel()}}
        </div>
      </div>
      <div fxLayoutGap="20px">
        <div fxFlex="100">
          <h5 style="margin-bottom: 0.5em">Service Contract</h5>
          {{getServiceContractLabel()}}
        </div>
      </div>
      <div fxLayoutGap="20px">
        <div fxFlex="100">
          <fd-input [parentForm]="formGroup" [field]="fields.name"></fd-input>
        </div>
      </div>
      <h5>Permissões</h5>
      <div fxLayoutGap="20px">
        <mat-error *ngIf="formGroup.controls.roles.hasError('required') && formGroup.controls.roles.touched">
          {{fields?.roles.messages?.required}}
        </mat-error>
      </div>
      <!-- Using fxFlex="100" (vs 50 in add-profile) to prevent long role labels from breaking into multiple lines -->
      <div fxLayoutGap="20px">
        <div fxFlex="100">
          <div *ngFor="let item of roles; let i = index" class="checkbox-item">
            <mat-checkbox (change)="onCheckboxChange(item, $event)" [value]="item.value" [checked]="item.selected" class="fd-checkbox" [id]="item.value">{{item.label}}</mat-checkbox>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div mat-dialog-actions>
    <div style="width: 100%; align-content: center">
      <fd-button mat-button fdSecondaryLarge [content]="'Cancelar'" (trigger)="close()"> </fd-button>
      <fd-button fdPrimaryLarge mat-flat-button [content]="'Salvar'" (trigger)="update()"> </fd-button>
    </div>
  </div>
</div>
